<template lang="pug">
  .ajax-multiselect#ajax-multiselect(@click="!disabled ? receiveData() : false" :class="{'is-empty': isEmpty}")
    label.typo__label(for="ajax-multiselect")
    multiselect(
      v-model="selectedData"
      :label="label"
      :trackBy="trackBy"
      open-direction="bottom"
      :options="options"
      :multiple="multiple"
      :searchable="searchable"
      :loading="isLoading"
      :max-height="500"
      :show-no-results="true"
      :close-on-select="closeOnSelect"
      :hide-selected="hideSelected"
      :clear-on-select="true"
      :disabled="disabled"
      :selectLabel="selectLabel"
      :placeholder="labelText"
      :class="{'is-multiple': multiple}"
    )
</template>

<script>
import { mapGetters } from 'vuex'
import { gettext } from '@/services/TranslateHandler'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
const _ = require('lodash')

export default {
  name: 'AjaxMultiselect',
  components: {
    Multiselect
  },
  data () {
    return {
      selectedData: [],
      items: [],
      isLoading: false,
      count: 0
    }
  },
  props: {
    action: {
      default: () => {
        return {
          method: '',
          params: {}
        }
      }
    },
    returnItem: {
      default: ''
    },
    disabled: {
      default: false
    },
    value: {
      default: () => {
        return []
      }
    },
    labelText: {
      default: gettext('Select option')
    },
    searchable: {
      default: false
    },
    multiple: {
      default: true
    },
    label: {
      default: 'name'
    },
    trackBy: {
      default: 'id'
    },
    closeOnSelect: {
      default: false
    },
    selectLabel: {
      default: ''
    },
    hideSelected: {
      default: true
    },
    receive: {
      default: true
    },
    sort: {
      default: 'id'
    },
    sortPriority: {
      default: () => {
        return []
      }
    }
  },
  methods: {
    gettext: gettext,
    receiveData () {
      this.isLoading = true
      return new Promise(resolve => {
        this.$store.dispatch(this.action.method, this.action.params).then(res => {
          this.count++
          this.items = res
          this.isLoading = false
          resolve(res)
        })
      })
    },
    setData (values, items) {
      if (_.isObject(values) && !this.multiple) {
        this.selectedData = values
      } else {
        if (this.multiple) {
          let result = []
          for (let item of values) {
            let val = _.find(items, {'id': item})
            if (val) result.push(val)
          }
          this.selectedData = result
        } else {
          this.selectedData = _.find(items, {'id': values})
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    isEmpty () {
      if (!this.selectedData) return !this.selectedData
      return !this.selectedData.length
    },
    options () {
      let arr = this.items
      if (this.sortPriority.length) {
        let sortItems = this.sortPriority
        sortItems.reverse().forEach((x) => {
          arr.forEach((y, index, array) => {
            if (y[this.sort] === x) {
              array.splice(index, 1)
              array.unshift(y)
            }
          })
        })
      }
      return arr
    }
  },
  watch: {
    receive: function (val) {
      if (val) {
        this.receiveData().then(res => {
          if (this.multiple) {
            this.selectedData = _.map(this.selectedData, item => {
              return _.find(res, {'id': item.id})
            })
          }
          return this.setData(this.value, res)
        })
      }
    },
    getLanguage: function () {
      if (this.action.method && this.receive) {
        this.receiveData().then(res => {
          if (!_.isObject(this.selectedData)) {
            this.selectedData = _.map(this.selectedData, item => {
              return _.find(res, {'id': item.id})
            })
          } else {
            this.selectedData = _.find(res, {'id': this.selectedData.id})
          }
        })
      }
    },
    selectedData: {
      deep: true,
      handler: function (value) {
        if (this.returnItem) {
          this.$emit('input', value[this.returnItem])
        } else {
          this.$emit('input', value)
        }
        if (this.count > 0) this.$emit('selected', this.selectedItem)
        if (this.count > 1) this.$emit('updated', this.selectedItem)
      }
    },
    disabled: function (value) {
      if (!value) this.receiveData()
      else this.selectedData = this.multiple ? [] : {}
    },
    value: function (val) {
      if (this.receive) {
        if (typeof val[0] === 'number') {
          this.receiveData().then(res => {
            this.setData(val, res)
          })
        } else if (_.isObject(val) && !this.multiple) {
          this.selectedData = val
        } else if (typeof val === 'number') {
          if (val === -1) {
            this.selectedData = this.multiple ? [] : {}
          } else {
            this.receiveData().then(res => {
              this.setData(val, res)
            })
          }
        }
      }
    }
  },
  mounted () {
    if (this.value && !this.disabled && this.receive) {
      let val = this.value
      if (_.isObject(val) && !_.isArray(val)) {
        this.selectedData = val
      } else {
        this.receiveData().then(res => {
          this.setData(val, res)
        })
      }
    }
  }
}
</script>

<style lang='scss'>
  .field {
    .field-body {
      .ajax-multiselect {
        .multiselect {
          &.multiselect--active {
            .multiselect__content-wrapper {
              position: absolute !important;
            }
          }
          .multiselect__single{
            color: #000;
          }
          &.is-multiple {
            .multiselect__single{
              color: #707070;
            }
          }
          &.is-empty {
            .multiselect__single{
              color: #707070;
            }
          }
          .multiselect__tag{
            background: #ededed;
            span{
              color: #000;
            }
            .multiselect__tag-icon{
              &:after{
                color: #bb1d2c;
              }
              &:hover, &:focus{
                background: #cccccc;
              }
            }
          }
          .multiselect__option--highlight{
            background: #ededed;
            color: #000;
            &:hover{
              color: #000;
            }
            &:after{
              background: #ededed;
              color: #000;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ajax-multiselect/index.vue